import { render, staticRenderFns } from "./OtherShipping.vue?vue&type=template&id=4e7b76ea"
import script from "./OtherShipping.vue?vue&type=script&lang=ts"
export * from "./OtherShipping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports